import { Component, OnDestroy, OnInit } from '@angular/core';
import { FlowwerInitializaterComponent } from '../../../../shared/components/flowwwer-initializater-component/flowwwer-initializater-component';
import { ModalController, NavController, ViewWillEnter } from '@ionic/angular';
import { LibraryService } from '../../../../core/services/library/library.service';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { CompanyService } from '../../../../shared/state/company/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../../../../shared/state/settings/settings.service';
import { ClinicDetailService } from '../../../../shared/state/clinic-detail/clinic-detail.service';
import { UserService } from '../../../../shared/state/user/user.service';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { RouterService } from '../../../../core/services/router/router.service';
import { SocialLoginQuery } from '../../../../shared/state/social-login/social-login.query';
import { SocialLoginService } from '../../../../shared/state/social-login/social-login.service';
import { LoadingService } from '../../../../shared/state/loading/loading.service';
import { filter, take } from 'rxjs/operators';
import { CompanyQuery } from 'src/app/shared/state/company/company.query';
import { Observable } from 'rxjs';
import { fade_in, fade_out } from 'src/app/core/animations/fade';
import { RegisterComponent } from '../register/register.component';

@Component({
    selector: 'app-social',
    animations: [fade_out, fade_in],
    templateUrl: './social.component.html',
    styleUrls: ['./social.component.scss'],
    host: {'class': 'ion-page-without-padding'}
})

/**TODO: Plantilla de como creo que es el mejor skeleton.
 * De esta forma, la animación es la mas simple y los estilos se usan en archivos scss
 * que admiten mas versatilidad.
 * Se usan estilos absolutos en el propio skeleton para simular el contenedor al que sustituyen de forma absoluta
 * Se simulan paddings también porque se situa en top:0 left:0
 * Aqui no podemos usar el fade_out_absolute porque en este caso, necesitamos que sea de primeras absolute para hacerlo mas simple y poder meterle ya todos los paddings y posiciones
 * Si lo pusieramos relative y luego usar el fade_out_absolute, cambiarian mucho los estilos entre relativo-absoluto y no se podria hacer.
 * El fade_out_absolute por ahora solo lo usamos para skeletons de footers y para el del header, que no pueden ser de primeras absolutos porque no aparecen
 */
export class SocialComponent
    extends FlowwerInitializaterComponent
    implements OnInit, ViewWillEnter, OnDestroy {
    socialLoginResponse$;
    /** Flowwwer template */
    clinicName$: Observable<string>;
    showBackButtonHeader$: Observable<boolean>;
    showClinicDetails: boolean;
    isGeneric$: Observable<boolean>;

    constructor(
        private socialLoginQuery: SocialLoginQuery,
        private socialLoginService: SocialLoginService,
        private loadingService: LoadingService,
        private router: Router,
        private companyQuery: CompanyQuery,
        private modalController: ModalController,
        libraryService: LibraryService,
        clinicDetailQuery: ClinicDetailQuery,
        companyService: CompanyService,
        activatedRoute: ActivatedRoute,
        settingsService: SettingsService,
        clinicDetailService: ClinicDetailService,
        navCtrl: NavController,
        userService: UserService,
        settingsQuery: SettingsQuery,
        userQuery: UserQuery,
        routerService: RouterService
    ) {
        super(
            activatedRoute,
            settingsService,
            userService,
            companyService,
            clinicDetailService,
            navCtrl,
            clinicDetailQuery,
            settingsQuery,
            userQuery,
            libraryService,
            routerService
        );
    }

    async ngOnInit(): Promise<void> {
        try {
            this.isLoadingContent = true;
            try {
                await this.initializeCompanyClinicUser(true);
            } catch (error) {
                this.isLoadingContent = false;
            }
            this.isLoadingContent = false;
        } catch (error) {
            this.isLoadingContent = false;
        }

        /** Flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
        this.showBackButtonHeader$ = this.settingsQuery.selectShowBackButtonHeader();
        this.showClinicDetails = this.settingsQuery.showClinicDetails;
        this.isGeneric$ = this.settingsQuery.selectIsGeneric()
    }

    ionViewWillEnter() {
        this.socialLoginService.resetStore();
        this.socialLoginResponse$?.unsubscribe();
        this.socialLoginResponse$ = this.socialLoginQuery
            .select()
            .pipe(
                filter((socialLogin) => {
                    return (
                        socialLogin.socialLoginSuccess ||
                        socialLogin.socialLoginFail
                    );
                }),
                take(1)
            )
            .subscribe(async (socialLogin) => {
                if (socialLogin.socialLoginSuccess) {
                    // TODO, si redigijo, controlar que no de error y me quede en la misma página porque ya estoy desuscrito

                    /** Social Login correcto, se ha encontrado al usuario, redirigir */
                    try {
                        await this.userService.checkUserAndLoad();
                        if (this.companyQuery.clientAdvisor) {
                            await this.userService.getReferrerData();
                        }
                    } catch (e) {
                        this.routerService.goToMainTabWithoutLogin();
                    }

                    /** Si puedo mostrar el tab de details redirijo a details, si no a perfil */

                    this.navCtrl.navigateBack([
                        '/' +
                            this.settingsQuery.systemKeyURL +
                            '/' +
                            this.clinicDetailQuery.id +
                            '/details',
                    ]);
                }

                if (socialLogin.socialLoginFail) {
                    // TODO, si redigijo, controlar que no de error y me quede en la misma página porque ya estoy desuscrito
                    /** Social Login incorrecto, NO se ha encontrado al usuario, ir a Registro con los datos precargados */
                    /** No borrar store, la borra la pantalla de REGISTRO  */
                    await this.router.navigate([
                        '/' +
                            this.settingsQuery.systemKeyURL +
                            '/' +
                            this.clinicDetailQuery.id +
                            '/register/default',
                    ]);
                }
            });
    }

    registerDefault() {
        this.router.navigate([
            '/' +
                this.settingsQuery.systemKeyURL +
                '/' +
                this.clinicDetailQuery.id +
                '/register/default',
        ]);
    }

    ngOnDestroy() {
        this.unsuscribeParamsQueryParams();
        this.socialLoginResponse$?.unsubscribe();
    }

    goBack() {
        /** Solo puedo volver atrás si no estoy en personalzas o si soy personalizada y tengo más de 1 centro */
        if (
            !this.settingsQuery.browser ||
            this.settingsQuery.showClinicDetails
        ) {
            this.navCtrl.navigateBack([
                '/' +
                    this.settingsQuery.systemKeyURL +
                    '/' +
                    this.clinicDetailQuery.id +
                    '/details',
            ]);
        } else {
            this.clinicDetailService.resetStore();
            this.navCtrl.navigateBack('/');
        }
    }
}
